import styled from "@emotion/styled";
import { TextField } from "@material-ui/core";
import { units } from "../../../../types/units";

export const CommentListContainer = styled.div`
  border-top: 1px solid;
  margin: 2rem 0;
  padding: 0;
  ${units({
    borderColor: "lightGrey",
  })}
`;

export const CommentListItem = styled.div`
  border-bottom: 1px solid;
  display: flex;
  padding: 2rem;
  margin: 0;
  ${units({
    textDecoration: "none",
    borderColor: "lightGrey",
  })}
`;

export const CommentText = styled.div`
  margin: 0.5rem 0 0;
`;

export const AddCommentContainter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  border: 1px solid;
  border-radius: 15px;
  margin: 2rem 0;
  padding: 0;
  position: relative;
  ${units({
    borderColor: "lightGrey",
  })}

  &:focus-within {
    outline: 2px solid;
    ${units({
      outlineColor: "skyBlue",
    })}
  }

  button {
    width: 120px;
    margin: 1rem 1rem 1rem auto;
  }
  label {
    display: none;
  }
`;

export const AddCommentAvatar = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: start;
  left: 0;
  padding: 1.5rem 2rem;
`;

export const CommentField = styled(TextField)`
  min-height: 4rem;
  min-width: 180px;
  width: calc(100% - 120px - 1rem);

  textarea {
    height: 28px;
    overflow: hidden;
    padding: 2rem 2rem 2rem 5.5rem;
    width: 100%;
  }
  .MuiInputBase-multiline {
    padding: 0;
  }
  .MuiInput-underline:before,
  .MuiInput-underline:after {
    display: none;
  }
`;
